import React from 'react';
import './AnimatedGradientBackground.css';

export default function AnimatedGradientBackground() {
  return (
    <div className="animated-gradient-container">
      <div className="gradient-blob gradient-blob-1"></div>
      <div className="gradient-blob gradient-blob-2"></div>
      <div className="gradient-blob gradient-blob-3"></div>
      <div className="gradient-blob gradient-blob-4"></div>
      <div className="gradient-blob gradient-blob-5"></div>
      <div className="gradient-overlay"></div>
    </div>
  );
}
